import styled from 'styled-components';

export const FormStepperContainer = styled.div`
  border-radius: 16px;
  border: 2px solid ${(props) => props.theme.palette.primary.main};
  padding: 24px;

  @media (min-width: 768px) {
    padding: 48px;
  }
`;
